import { InvestigationQuestionTypeEnum } from '@EHSNavigator/backend';
import * as Yup from 'yup';

export const getInvestigationReportingAddQuestionSchema = () => {
  return Yup.object().shape({
    questionType: Yup.string().required('Question Type is required'),
    question: Yup.string().required('Question is required'),
    answer: Yup.string().required('Answer is required'),
    options: Yup.array()
      .of(Yup.string())
      .when('questionType', {
        is: (val: string) =>
          val === InvestigationQuestionTypeEnum?.MultiOptions,
        then: (schema) =>
          schema
            .min(1, 'At least one option is required')
            .required('Options are required')
            .test('unique', 'Options must be unique', (value) => {
              if (!value) return true;
              const lowerCased = value.map((v) => v?.toLowerCase?.().trim?.());
              return new Set(lowerCased).size === lowerCased.length;
            }),
        otherwise: (schema) => schema.notRequired(),
      }),
  });
};
